import { createApp } from 'vue';

import App from './App.vue';
import i18n, { setI18nLocale } from './i18n';
import router from './router';
import './styles/entry.scss';
import { initAnalytics, trackPageView } from './utils/analytics';

/**
 * The locale's messages must be in place before the incoming route's component
 * renders, otherwise the first paint shows raw key paths — or Estonian copy on a
 * Russian URL. The guard is async for exactly this reason.
 */
router.beforeEach(async (to) => {
  await setI18nLocale(to.meta.locale);
  document.documentElement.lang = to.meta.locale;
});

router.afterEach((to) => {
  trackPageView(to.fullPath);
});

const app = createApp(App);

app.use(i18n);
app.use(router);

// Waiting for the router settles the initial navigation, so the guard above has
// loaded the right message tree by the time anything mounts.
await router.isReady();

app.mount('#app-container');

// Returning visitors who already consented get their tags on boot; everyone
// else gets them from the consent banner.
initAnalytics();
